import React from 'react'
import DashboardNavbar from './DashboardNavbar'
import Footer from './Footer'

const AppLayout = ({ children }: { children: React.ReactNode }) => {
	return (
		<>
			<DashboardNavbar />
			<div className="min-h-[90svh]">{children}</div>
			<Footer />
		</>
	);
};

export default AppLayout